module.exports = __webpack_public_path__ + "img/ink_envelope.57426f3a.png";